import { Alert } from '@ztechapps/webui.util'
import React from 'react'

export const Layout = () => {
  return (
    <Alert>
      <h1>Customer Page here</h1>
    </Alert>
  )
}
